import React, { ReactNode } from 'react'
import Link from './Link'
import { useFileDownload } from '@hooks'

interface Props {
  url: string
  children: ReactNode
}

export default function FileDownloadLink({ url, children }: Props) {
  const startFileDownload = useFileDownload()

  return url ? <Link onClick={() => startFileDownload(url)}>{children}</Link> : null
}
